import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const refCodeClientGroupMutations: UpdatesConfig['Mutation'] = {
  refCodeClientGroupCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('refCodeClientGroups', cache);
  },
  refCodeClientGroupUpdate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('refCodeClientGroups', cache);
  },
  refCodeClientGroupDelete: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('refCodeClientGroups', cache);
  },
};

export default refCodeClientGroupMutations;
